// @ts-nocheck

import dayjs from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LogTimelineRow } from '../LogTimelineRow'

class ChartLogList extends Component<any, any> {
  render() {
    const { fixedPictures } = this.props

    const logs = _.sortBy(this.props.logs, (d) => -dayjs(d.timeLogged).toDate())

    return (
      <div style={{ ...styles.leftContainer, ...this.props.style }}>
        <ul style={styles.logsList}>
          {logs.map((log, i) => (
            <LogTimelineRow
              fixedPictures={fixedPictures}
              mock={this.props.mock}
              dateFormat="ddd DD MMM HH:mm"
              date={(d) => ''}
              key={log.id || i}
              log={log}
              index={i}
              total={logs.length}
            />
          ))}
        </ul>
      </div>
    )
  }
}

ChartLogList.propTypes = {
  transparentImages: PropTypes.bool,
  logs: PropTypes.array,
  style: PropTypes.object,
  mock: PropTypes.bool
}

const styles = {
  leftContainer: {
    marginTop: 42,
    marginBottom: 100
    // display: 'flex',
  },
  container: {
    margin: '0 auto',
    display: 'flex',
    maxWidth: '80%',
    marginTop: 80,
    marginBottom: 100
  },
  heading: {
    paddingTop: 30,
    paddingBottom: 20
  },
  logsList: {
    paddingLeft: 0,
    margin: '0 auto',
    listStyleType: 'none'
  }
}

export default ChartLogList
